import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';

import StandardDataGrid from '../../../components/Common/StandardDataGrid';
import CompanyModal from '../../../components/DataSections/Company/Modal/CompanyModal';
import { useSystemError } from '../../../components/Error/SystemErrorContext';
import { CompanyProfileModel } from '../../../models/data-sections/company/profileModel';
import { trimDate } from '../../../utils/commonUtils';

interface CompanyProfilesProps {
  searchExecutionId: string;
  companies: CompanyProfileModel[] | null;
  isLoading: boolean;
}

const CompanyProfiles: React.FC<CompanyProfilesProps> = ({ searchExecutionId, companies, isLoading }) => {
  const { triggerSystemError } = useSystemError();

  const columns: GridColDef<CompanyProfileModel>[] = [
    { field: 'company_name', headerName: 'Company Name', width: 250 },
    { field: 'ticker', headerName: 'Ticker', width: 100 },
    { field: 'sector', headerName: 'Sector', width: 150 },
    { field: 'industry', headerName: 'Industry', width: 150 },
    { field: 'market_capitalization', headerName: 'Market Cap', width: 150 },
    { field: 'country', headerName: 'Country', width: 120 },
    { field: 'pe_ratio', headerName: 'PE Ratio', width: 120 },
    { field: 'eps', headerName: 'EPS', width: 100 },
    { field: 'dividend_yield', headerName: 'Dividend Yield', width: 130 },
    { field: 'price', headerName: 'Price', width: 100, type: 'number' },
    { field: 'volume', headerName: 'Volume', width: 120, type: 'number' },
    {
      field: 'latest_trading_day',
      headerName: 'Last Trade',
      width: 130,
      renderCell: (params) => <>{trimDate(params.value as string)}</>,
    },
    {
      field: 'official_site',
      headerName: 'Website',
      width: 200,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            {params.value}
          </a>
        ) : (
          'N/A'
        ),
    },
  ];

  const rows = companies?.map((company, index) => ({ id: index, ...company })) || [];

  return (
    <StandardDataGrid
      isLoading={isLoading}
      singleGrid={{
        rows,
        columns,
        modalRenderer: (row) => (
          <CompanyModal
            searchExecutionId={searchExecutionId}
            selected_company={row}
            onClose={() => {}}
          />
        ),
      }}
    />
  );
};

export default CompanyProfiles;
